import CallsRing from 'components/prospection/CallsRing';

/**
 * The daily goal while the list is being composed, in the colours of the
 * goals banner: how many prospects to pick to reach it (`left`: the goal
 * less the calls already made today), and a ring of those `picked`. The
 * goal is no limit: past it, one may pick more.
 */
const GoalBanner = ({ left, picked }) => (
  <div className="flex items-center gap-4 rounded-2xl bg-info-bg p-4">
    <div className="flex min-w-0 flex-1 flex-col gap-1">
      <p className="font-title text-lg font-semibold leading-7 text-ink">Objectif du jour</p>
      <p className="font-title text-sm leading-5 text-body">
        {left > 0
          ? `Sélectionnez ${left} prospect${left > 1 ? 's' : ''} pour atteindre l’objectif journalier.`
          : 'Objectif atteint : vous pouvez en appeler d’autres.'}
      </p>
    </div>
    {left > 0 && <CallsRing done={picked} callbacks={0} total={left} label={`${picked} sélectionnés sur ${left}`} />}
  </div>
);

export default GoalBanner;
